import React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from '../Widget.st.css';
import { TEXT_DIRECTION } from '../../../../constants';

export const ProfilePolicyFootnote: React.FC = () => {
  const { t } = useTranslation();
  const { isRTL } = useEnvironment();

  return (
    <div
      data-hook="signup-automatic-profile-policy-footnote"
      dir={isRTL ? TEXT_DIRECTION.RTL : TEXT_DIRECTION.LTR}
    >
      <Text className={classes.profilePolicyFootnoteText}>
        {t('memberAuthentication.uouScreens.signUpForm.profilePolicyFootnote')}
      </Text>
    </div>
  );
};
